var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.2112,
    r: 15,
    fill: "#2A5050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9737 2.21124C7.79957 2.21124 2 7.94039 2 15.0281C2 20.6937 5.71599 25.4895 10.871 27.1869C11.5156 27.3145 11.7516 26.9111 11.7516 26.5718C11.7516 26.2747 11.7304 25.2562 11.7304 24.195C8.12143 24.9591 7.3699 22.6671 7.3699 22.6671C6.78991 21.1817 5.93056 20.8 5.93056 20.8C4.74935 20.0148 6.0166 20.0148 6.0166 20.0148C7.32688 20.0997 8.01441 21.3304 8.01441 21.3304C9.17411 23.2825 11.0429 22.7309 11.7947 22.3914C11.902 21.5638 12.2459 20.9909 12.611 20.6726C9.73259 20.3755 6.70414 19.2721 6.70414 14.349C6.70414 12.9484 7.21932 11.8026 8.03566 10.9115C7.90686 10.5932 7.45567 9.27736 8.16472 7.51617C8.16472 7.51617 9.26016 7.17659 11.7301 8.83179C12.7876 8.55123 13.8782 8.40851 14.9737 8.40731C16.0691 8.40731 17.1858 8.55601 18.217 8.83179C20.6872 7.17659 21.7827 7.51617 21.7827 7.51617C22.4917 9.27736 22.0403 10.5932 21.9115 10.9115C22.7493 11.8026 23.2432 12.9484 23.2432 14.349C23.2432 19.2721 20.2148 20.3541 17.3149 20.6726C17.7876 21.0757 18.1955 21.8395 18.1955 23.0492C18.1955 24.7679 18.1742 26.1473 18.1742 26.5716C18.1742 26.9111 18.4106 27.3145 19.0548 27.1872C24.2099 25.4893 27.9259 20.6937 27.9259 15.0281C27.9471 7.94039 22.1263 2.21124 14.9737 2.21124Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubPrimary);
export default __webpack_public_path__ + "static/media/github-primary.4b306eb561fcfd8b00c4023fb0f37206.svg";
export { ForwardRef as ReactComponent };